/**
 * @generated SignedSource<<2124a38f7df0697ec79989af6bc280e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type job_useMismatchingSkillsJob$data = {
  readonly jobSkills: ReadonlyArray<{
    readonly groupIndex: number | null | undefined;
    readonly required: boolean | null | undefined;
    readonly requiredYears: number | null | undefined;
    readonly skill: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  }>;
  readonly " $fragmentType": "job_useMismatchingSkillsJob";
};
export type job_useMismatchingSkillsJob$key = {
  readonly " $data"?: job_useMismatchingSkillsJob$data;
  readonly " $fragmentSpreads": FragmentRefs<"job_useMismatchingSkillsJob">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "job_useMismatchingSkillsJob",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "JobSkill",
      "kind": "LinkedField",
      "name": "jobSkills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "required",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredYears",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupIndex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "979cbe876f42d82bf59eb86d7583399c";

export default node;
